import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import styles from './styles/styles.module.css';
import { BeatLoader } from 'react-spinners';

interface ModalSmallInterface {
  title: String;
  text: String;
  loading: boolean;
  submitButtonText: string;
  submitHandler: () => void;
  cancelHandler: () => void;
}

const ModalSmall: React.FC<ModalSmallInterface> = ({
  title,
  text,
  submitButtonText,
  submitHandler,
  cancelHandler,
  loading,
}) => {
  async function handleSubmit() {
    await submitHandler();
  }

  function handleCancel() {
    cancelHandler();
  }

  return (
    <div className={styles.wrapper}>
      <div
        className="modal show"
        style={{ display: 'block', position: 'initial' }}
      >
        <Modal.Dialog>
          <Modal.Header onHide={handleCancel} closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{text}</p>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleCancel} variant="secondary">
              Cancel
            </Button>
            <Button
              className={styles.submitButton}
              disabled={loading}
              onClick={() => {
                if (!loading) {
                  handleSubmit();
                } else {
                  return;
                }
              }}
              variant="primary"
            >
              {loading ? (
                <BeatLoader margin={0} size={10} color="white" />
              ) : (
                `${submitButtonText}`
              )}
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    </div>
  );
};

export default ModalSmall;
